<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="large-panel" style="min-height: 60vh;height: auto;margin-top: -35vh;"  @click.stop>
                <div class="dialog-title" v-t="'message.item_edit_help_link_setting'"></div>
                <hr class="dialog-hr">
                <div class="dialog-body">
                    <el-form>
                        <div class="description" v-t="'message.item_edit_help_link_setting_manual_item_description'"></div>
                        <!-- 設定内容 -->
                        <table width="100%">
                            <tr class="object-titlebox" style="display: table-row;">
                                <td class="object-titlebox-text" style="padding-left:20px;"
                                    v-t="'message.item_setting_value'"></td>
                                <td class="setting-switch-header" v-t="'message.title_client_enabling'"></td>
                            </tr>
                            <!-- Buddycomにヘルプを表示する -->
                            <tr class="setting-name-1">
                                <td class="object-item">
                                    <span v-t="'message.item_buddycom_enable_help_link'"></span>
                                    <el-tooltip effect="dark" placement="top-start">
                                        <div slot="content" style="text-align:left"
                                            v-html="$t('message.item_hint_buddycom_enable_help_link')"></div>
                                        <img class="icon-help" :src="require('@/assets/icon_help.svg')" />
                                    </el-tooltip>
                                </td>
                                <td class="setting-switch">
                                    <el-switch v-model="enabeleHelpLink" active-color="#5171cb"
                                        @change="handleEnableHelpLinkChange()">
                                    </el-switch>
                                </td>
                            </tr>
                        </table>
                        <!-- 表示内容 -->
                        <table v-show="enabeleHelpLink" style="width: 100%;">
                            <tr class="object-titlebox" style="display: table-row;">
                                <td class="object-titlebox-text" style="padding-left:20px;"
                                    v-t="'message.display_contents'"></td>
                                <td class="setting-switch-header" v-t="'message.title_client_enabling'"></td>
                            </tr>
                            <!-- Buddycom公式のヘルプページを表示する -->
                            <tr class="setting-name-1">
                                <td class="object-item">
                                    <span v-t="'message.item_buddycom_faq_link'"></span>
                                    <el-tooltip effect="dark" placement="top-start">
                                        <div slot="content" style="text-align:left"
                                            v-html="$t('message.item_hint_buddycom_faq_link')"></div>
                                        <img class="icon-help" :src="require('@/assets/icon_help.svg')" />
                                    </el-tooltip>
                                </td>
                                <td class="setting-switch">
                                    <el-switch v-model="inputItems['enableFaqLink'].value" active-color="#5171cb"
                                        @change="setButtonStatus()">
                                    </el-switch>
                                </td>
                            </tr>
                            <!-- 独自のヘルプリンクを表示する -->
                            <tr class="setting-name-1">
                                <td class="object-item">
                                    <span v-t="'message.item_custom_link'"></span>
                                    <el-tooltip effect="dark" placement="top-start">
                                        <div slot="content" style="text-align:left"
                                            v-html="$t('message.item_hint_custom_link')"></div>
                                        <img class="icon-help" :src="require('@/assets/icon_help.svg')" />
                                    </el-tooltip>
                                </td>
                                <td class="setting-switch">
                                    <el-switch active-color="#5171cb" v-model="inputItems['enableCustomLink'].value"
                                        @change="handleEableCustomLinkChange()">
                                    </el-switch>
                                </td>
                            </tr>
                        </table>
                        <!-- 表示名 -->
                        <table width="100%" v-show="inputItems['enableCustomLink'].value">
                            <tr class="setting-name-1">
                                <td class="setting-input-header" v-t="'message.item_custom_link_name'">
                                </td>
                                <td>
                                    <el-form-item ref="customDisplayName"
                                        style="padding-right: 20px; vertical-align: center;">
                                        <el-input id="customDisplayName"
                                            :placeholder="$t('message.item_place_holder_custom_link_name')"
                                            v-model="inputItems['customDisplayName'].value"
                                            @compositionstart.native="compositionStart($event.target.id)"
                                            @compositionend.native="compositionEnd($event.target.id)"
                                            @input.native="inputCheck($event.target.id)"
                                            :disabled="!this.inputItems['enableCustomLink'].value"
                                            clearable
                                            @clear="handleEableCustomLinkChange()" />
                                    </el-form-item>
                                </td>
                            </tr>
                            <!-- URL -->
                            <tr class="setting-name-1">
                                <td class="setting-input-header" v-t="'message.item_custom_link_url'"></td>
                                <td>
                                    <el-form-item ref="url" style="padding-right: 20px;">
                                        <el-input id="url" :placeholder="$t('message.item_place_holder_url')"
                                            v-model="inputItems['url'].value"
                                            @compositionstart.native="compositionStart($event.target.id)"
                                            @compositionend.native="compositionEnd($event.target.id)"
                                            @input.native="inputCheck($event.target.id)"
                                            :disabled="!this.inputItems['enableCustomLink'].value"
                                            clearable
                                            @clear="handleEableCustomLinkChange()" />
                                    </el-form-item>
                                </td>
                            </tr>
                        </table>
                    </el-form>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" type="button" v-t="'message.button_cancel'"
                        @click="$emit('cancel')"></el-button>
                    <el-button class="dialog-ok-button" :disabled="disableSave" v-t="'message.button_save'"
                        @click="saveChange()"></el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import commonValidate from '../../../common-validate.js';
export default {
    props: ['helpLinkSettingInfo'],

    data() {
        return {
            disableSave: true,
            inputItems: {
                enableFaqLink: { value: false, valid: true },
                enableCustomLink: { value: false, valid: true },
                customDisplayName: { validationRule: "reqDisplayName", value: "", valid: true, isComposing: false },
                url: { validationRule: "reqUrl", value: "", valid: true, isComposing: false },
            },
            enabeleHelpLink: false,
        }
    },

    created: function () {
        this.inputItems['enableFaqLink'].value = this.helpLinkSettingInfo.enableFaqLink;
        this.inputItems['enableCustomLink'].value = this.helpLinkSettingInfo.enableCustomLink;
        this.inputItems['customDisplayName'].value = this.helpLinkSettingInfo.customDisplayName;
        this.inputItems['url'].value = this.helpLinkSettingInfo.url;

        this.enabeleHelpLink = this.inputItems['enableFaqLink'].value || this.inputItems['enableCustomLink'].value;
    },

    methods: {
        handleEableCustomLinkChange() {
            if (this.inputItems['enableCustomLink'].value) {
                this.inputCheck('customDisplayName');
                this.inputCheck('url');
            }
            this.setButtonStatus();
        },
        setButtonStatus() {
            if (this.inputItems['enableCustomLink'].value) {
                this.disableSave = !commonValidate.checkFormValidation(this.inputItems)
            } else {
                this.$refs['customDisplayName'].clearValidate();
                this.$refs['url'].clearValidate();
                this.disableSave = false;
            }

            if (!this.inputItems['enableFaqLink'].value && !this.inputItems['enableCustomLink'].value) {
                this.disableSave = true;
            }
        },
        handleEnableHelpLinkChange() {
            if (this.enabeleHelpLink) {
                if (!this.inputItems['enableFaqLink'].value && !this.inputItems['enableCustomLink'].value) {
                    this.disableSave = true;
                    return;
                }
            } else {
                this.inputItems['enableFaqLink'].value = false;
                this.inputItems['enableCustomLink'].value = false;

                if (this.inputItems['enableCustomLink'].value) {
                    this.$refs['customDisplayName'].clearValidate();
                    this.$refs['url'].clearValidate();
                }
                this.disableSave = false;
            }
        },
        compositionStart(eventTargetId) {
            this.inputItems[eventTargetId].isComposing = true;
        },
        compositionEnd(eventTargetId) {
            this.inputItems[eventTargetId].isComposing = false;
            this.inputCheck(eventTargetId)
        },
        inputCheck(eventTargetId) {
            if (this.inputItems[eventTargetId].isComposing) return;

            let validateResult = commonValidate.validateItem(this.$i18n, this.inputItems[eventTargetId].validationRule, this.inputItems[eventTargetId].value);
            if (validateResult.valid) {
                this.inputItems[eventTargetId].valid = true;
                this.$refs[eventTargetId].clearValidate();
            } else {
                this.inputItems[eventTargetId].valid = false;
                this.$refs[eventTargetId].validateState = "error";
                this.$refs[eventTargetId].validateMessage = validateResult.message;
            }
            this.setButtonStatus();
        },
        saveChange: function () {
            let helpLinkSettingRequest = {}

            helpLinkSettingRequest['enableFaqLink'] = this.inputItems['enableFaqLink'].value;
            helpLinkSettingRequest['enableCustomLink'] = this.inputItems['enableCustomLink'].value;
            helpLinkSettingRequest['customDisplayName'] = this.inputItems['customDisplayName'].value;
            helpLinkSettingRequest['url'] = this.inputItems['url'].value;

            this.$emit('save', helpLinkSettingRequest);
        }
    }
}
</script>

<style scoped>
.dialog-body {
    height: calc(65vh - 180px);
    font-size: 14px;
    overflow: auto;
    padding: 20px;
}

.setting-name-1 {
    padding-left: 20px;
    padding-top: 10px;
    vertical-align: middle;
}

.description {
    padding-bottom: 20px;
}

.setting-switch {
    text-align: right;
    padding-right: 20px;
}

.setting-switch-header {
    text-align: right;
    padding-right: 20px;
    color: #848991;
    font-size: 12px;
}

.setting-input-header {
    width: 15%;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 20px;
    padding-right: 20px;
    font-size: 14px;
    text-align: right;
    vertical-align: top;
}
</style>
